import { render } from "./esp32atomhubswitch.vue?vue&type=template&id=2217783a"
import script from "./esp32atomhubswitch.vue?vue&type=script&lang=js"
export * from "./esp32atomhubswitch.vue?vue&type=script&lang=js"

import "./esp32atomhubswitch.vue?vue&type=style&index=0&id=2217783a&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__